export async function checkResidentCard(payload) {
  try {
    const resp = await fetch(
      "https://checkresidentcard-dikpysyoqq-uc.a.run.app",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    const raw = await resp.text();
    let data;
    try {
      data = JSON.parse(raw);
    } catch {
      data = { raw };
    }

    if (!resp.ok) throw new Error(`HTTP ${resp.status}: ${raw.slice(0, 200)}`);
    console.log("데이터 발송 결과:", data);
    return data;
  } catch (error) {
    console.error("데이터 발송 에러:", error);
    throw error;
  }
}
